module.exports = __webpack_public_path__ + "media/images/landing/bg/case-johany-a1bb4a9aef4c8db5bb2dbd62c1a942a1.jpg";